/**
 * wizImage组件demo
 * @description wiz封装的img
 * @author mll
 * @date 2020-10-9
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool } from '../../../tool'
let { WizCard, WizButton } = component_tool;
let { WizContainer } = framework_tool;

class Image extends WizContainer {

  componentName = 'ImageDemo';

  constructor(props) {
    super(props);
    this.state = {
      fileId: '20200929140433d51f86345b774b0abd'
    }
  }


  _render() {
    return (
      <>
        <WizCard title='普通用法'>
          <img src ={getOssFilePath('20200422164341f4e04aa097324ffc80')}/>
        </WizCard>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {

  };
};

export default connect(mapStateToProps)(Image);
